import { render, staticRenderFns } from "./QueryDataTable.vue?vue&type=template&id=7f96428e&scoped=true&"
import script from "./QueryDataTable.vue?vue&type=script&lang=ts&"
export * from "./QueryDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96428e",
  null
  
)

export default component.exports